module.exports = __webpack_public_path__ + "static/media/persona-big.7e00f5df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/persona-big.jpg
// module id = 70
// module chunks = 0